'use client';

import { AppNextLink } from '@/features/app-next-link';
import { useCartReturnUrl } from '@/app/(order)/cart/_utils/use-cart-return-url';
import { OrderPagesURL } from '@/app/(order)/types';
import CartCounterButton from '@/app/(pdp)/_components/buttons/add-to-cart-button/cart-counter-button';
import Logo from './logo';
import UserProfile from './user-profile';
import MenuButton from './mobile-menu/menu-button';
import MobileMenu from './mobile-menu/mobile-menu';
import MobileSearch from './mobile-menu/mobile-search';
import { SearchBox } from '../search';
function MainBar() {
  const {
    setCartBackReturnUrl
  } = useCartReturnUrl();
  return <div className='layout-container relative z-10 flex items-center justify-between bg-white lg:h-[90px]' data-sentry-component="MainBar" data-sentry-source-file="main-bar.tsx">
            <div className='flex items-center gap-2 lg:gap-4'>
                <MenuButton data-sentry-element="MenuButton" data-sentry-source-file="main-bar.tsx" />
                <Logo data-sentry-element="Logo" data-sentry-source-file="main-bar.tsx" />
                <SearchBox mode='desktop' data-sentry-element="SearchBox" data-sentry-source-file="main-bar.tsx" />
            </div>

            <div className='flex items-center gap-2 md:gap-3 lg:justify-end lg:gap-5'>
                <MobileSearch data-sentry-element="MobileSearch" data-sentry-source-file="main-bar.tsx" />

                <UserProfile data-sentry-element="UserProfile" data-sentry-source-file="main-bar.tsx" />

                <AppNextLink href={OrderPagesURL.CART} prefetch={false} aria-label='Cart' onClick={setCartBackReturnUrl} className='flex items-center' data-sentry-element="AppNextLink" data-sentry-source-file="main-bar.tsx">
                    <CartCounterButton data-sentry-element="CartCounterButton" data-sentry-source-file="main-bar.tsx" />
                </AppNextLink>
            </div>

            <MobileMenu data-sentry-element="MobileMenu" data-sentry-source-file="main-bar.tsx" />
        </div>;
}
export default MainBar;